import { request } from './request'

// 官网菜单
function getWebMenuList(data) {
    return request({
        url: '/web/product/getProductMenuInfo',
        method: 'POST',
        data: data
    })
}

//跳转过来获取信息
function getProductInfo(data) {
    return request({
        url: '/web/product/getProduct',
        method: 'POST',
        data: data
    })
}

export default {
    getWebMenuList,
    getProductInfo
}
